import { render, staticRenderFns } from "./InvestmentPlan1.vue?vue&type=template&id=0e42b357&"
import script from "./InvestmentPlan1.vue?vue&type=script&lang=js&"
export * from "./InvestmentPlan1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports